import { deleteField, writeBatch } from 'firebase/firestore';
import { createRefPath, createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import { useCallback, useContext, useState } from 'react';
import { ParentContext } from '../ParentContext';
import { useCleanData } from './useCleanData';
import { _cacheGroupTypes } from './useTimestamp';
import { logBatch } from 'global/cnr/reducers/reducerHelpers/logging';

const _allowUpdates = true

const _allowDeletePrior = false
const _allowDocs = true
const _allow_documents = true
const _allow_settings = true

export const useRecreateData = () => {

  const parentContext = useContext(ParentContext);
  const { fns, states } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { database_fns } = fns ?? {}
  const { mainDb } = app_state ?? {}
  const { pathViews } = paps_state ?? {}

  const [updating, setUpdating] = useState()

  const { cleanUpData } = useCleanData()

  const updateSettingsData = useCallback(async ({ viewItems, views, callback }) => {
    const batch = writeBatch(mainDb);
    const refPath_viewItems = createRefPath(['settings', pathViews.events, 'settings', 'viewItems']);
    const refPath_views = createRefPath(['settings', pathViews.events, 'settings', 'views']);
    //refPath, data, merge, dispatch, batch, altDb
    console.log('refPath_viewItems', refPath_viewItems, viewItems)
    console.log('refPath_views', refPath_views, views)
    database_fns.set_doc(refPath_viewItems, viewItems, true, null, batch)
    database_fns.set_doc(refPath_views, views, true, null, batch)
    logBatch(batch)
    if (_allow_settings) {
      await batch.commit();
    }
  }, [])

  const updateCollectionsData = useCallback(async ({ dataToUpdate, opts, callback }) => {

    setUpdating(true)

    const batch = writeBatch(mainDb);

    console.clear()
    console.group('updateCollectionsData')
    console.log('opts', opts)

    const { collectionKey, deletePrior, forRemove, selectedProp } = opts

    const dataItems = dataToUpdate?.[collectionKey]
    const _collectionToUpdate = selectedProp ? filterDataItem(dataItems, selectedProp) : dataItems

    if (deletePrior && _allowDeletePrior) {
      const batch_delete = writeBatch(mainDb);
      _.forEach(_collectionToUpdate, (di, dik) => {
        const refPath_doc_delete = createRefPath_event(pathViews, [collectionKey, dik]);
        database_fns.delete_doc(refPath_doc_delete, null, batch_delete)
      })
      const refPath_documents_delete = createRefPath_event(pathViews, ['_documents', collectionKey]);
      database_fns.delete_doc(refPath_documents_delete, null, batch_delete)
      logBatch(batch_delete)
      if (_allowUpdates) {
        await batch_delete.commit();
      }
    }

    const dtu_documents = {}

    _.forEach(_collectionToUpdate, (di, dik) => {
      // clean up the data
      const _di = cleanUpData({ data: di, removeUnderscores: true })

      // append dtu_documents
      if (forRemove) {
        dtu_documents[`${dik}`] = deleteField()
      } else {
        dtu_documents[`${dik}`] = _di
      }

      const refPath_doc_set = createRefPath_event(pathViews, [collectionKey, dik]);

      // _doc  ref
      if (_allowDocs) {
        console.group('refPath_doc', refPath_doc_set)
        console.log('_di', _di)
        console.groupEnd()
        if (forRemove) {
          database_fns.delete_doc(refPath_doc_set, null, batch)
        } else {
          database_fns.set_doc(refPath_doc_set, _di, true, null, batch)
        }
      }
    })

    // _documents ref
    //_refPath, dataToUpdate, null, batch
    if (_allow_documents) {
      const refPath_documents_set = createRefPath_event(pathViews, ['_documents', collectionKey]);
      console.log('refPath_documents', refPath_documents_set)
      console.log('dtu', dtu_documents)
      console.groupEnd()
      database_fns.set_doc(refPath_documents_set, dtu_documents, true, null, batch)
    }

    if (_allowUpdates) {
      const _timestamp = Date.now()
      database_fns.update_timestamp(_cacheGroupTypes.eventInfo, pathViews.events, _timestamp, batch)
      await batch.commit();
    }

    setUpdating()
    callback()
    // recreateDataHelpers.updateCollectionsData(mainDb, database_fns, pathViews, dataToUpdate, opts, fn_cls)
  }, []);

  const filterData = useCallback(({ data, selectedProp, allowNames }) => {
    return filterDataItem(data, selectedProp, allowNames)
  }, [])

  return {
    updateCollectionsData,
    updateSettingsData,
    filterData,
    updating,
  }
}

const filterDataItem = (dataItems, selectedProp, allowNames) => {
  const selectedProps = _.castArray(selectedProp);

  const _filteredData = _.mapValues(dataItems, (dataItem) => {
    const hasAnySelectedProp = _.some(
      selectedProps,
      (prop) => dataItem[prop] !== undefined && dataItem[prop] !== null
    );

    if (!hasAnySelectedProp) return null;

    const selectedValues = _.pick(dataItem, selectedProps);

    if (allowNames) {
      return {
        ...selectedValues,
        name:
          selectedProps.length === 1
            ? dataItem[selectedProps[0]]
            : undefined,
        firstName: dataItem.firstName,
        lastName: dataItem.lastName,
      };
    }

    return selectedValues;
  });

  return _.omitBy(_filteredData, _.isNil);
};